(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sora-back-to-top"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (gebeurtenis) {
    var link = gebeurtenis.target.closest ? gebeurtenis.target.closest('[data-sora-naar-boven]') : null;
    if (!link) return;
    gebeurtenis.preventDefault();
    var minder = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var gedrag = link.getAttribute('data-gedrag') === 'direct' || minder ? 'auto' : 'smooth';
    window.scrollTo({ top: 0, left: 0, behavior: gedrag });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sora-bundle-upsell"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('sora-kruisverkoop')) return;

    const routes = () => {
      const r = (window.Theme && window.Theme.routes) || {};
      const winkelwagen = r.cart_url || '/cart';
      return { toevoegen: r.cart_add_url || '/cart/add.js', winkelwagen, json: winkelwagen + '.js' };
    };

    let events = null;
    const laadEvents = async () => {
      if (events !== null) return events;
      try {
        events = await import('@shopify/events');
      } catch (fout) {
        events = false;
      }
      return events;
    };

    /* Voegt een variant toe en laat Horizon (winkelwagenlade, teller) meelopen via de cartevents. */
    const voegToe = async (variantId, bron) => {
      const r = routes();
      const ev = await laadEvents();
      let uitgesteld = null;
      if (ev && ev.CartLinesUpdateEvent) {
        try {
          uitgesteld = ev.CartLinesUpdateEvent.createPromise();
          bron.dispatchEvent(
            new ev.CartLinesUpdateEvent({
              action: 'add',
              context: 'product',
              lines: [{ merchandiseId: String(variantId), quantity: 1 }],
              promise: uitgesteld.promise,
            })
          );
        } catch (fout) {
          uitgesteld = null;
        }
      }

      const sectieIds = Array.from(document.querySelectorAll('cart-items-component'))
        .map((c) => c.dataset.sectionId)
        .filter(Boolean)
        .join(',');

      let gelukt = false;
      let secties;
      try {
        const antwoord = await fetch(r.toevoegen, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: sectieIds || undefined }),
        });
        const data = await antwoord.json().catch(() => ({}));
        gelukt = antwoord.ok && !data.status;
        secties = data.sections;
      } catch (fout) {
        gelukt = false;
      }

      if (uitgesteld) {
        let wagen = null;
        try {
          const antwoord = await fetch(r.json, { headers: { Accept: 'application/json' } });
          wagen = await antwoord.json();
        } catch (fout) {
          wagen = null;
        }
        if (wagen && wagen.items) {
          uitgesteld.resolve({
            cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(wagen),
            detail: {
              items: wagen.items,
              source: 'sora-kruisverkoop',
              sourceId: bron.id || '',
              itemCount: wagen.item_count,
              sections: secties,
              didError: !gelukt,
            },
          });
        } else {
          uitgesteld.reject(new Error('Winkelwagen niet opgehaald'));
        }
      } else if (gelukt) {
        window.location.assign(r.winkelwagen);
      }
      return gelukt;
    };

    /* Bedrag in centen naar tekst volgens het geldformaat van de winkel (amount_with_comma_separator enz.). */
    const geld = (centen, formaat) => {
      const bedrag = (centen / 100).toFixed(2);
      const [heel, deel] = bedrag.split('.');
      const metPunt = heel.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      const metKomma = heel.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      const sjabloon = formaat || '€' + '{'.repeat(2) + 'amount_with_comma_separator' + '}'.repeat(2);
      return sjabloon.replace(new RegExp('\\{\\{\\s*(\\w+)\\s*\\}\\}'), (_, soort) => {
        switch (soort) {
          case 'amount_with_comma_separator':
            return `${metPunt},${deel}`;
          case 'amount_no_decimals':
            return metKomma;
          case 'amount_no_decimals_with_comma_separator':
            return metPunt;
          default:
            return `${metKomma}.${deel}`;
        }
      });
    };

    /* Korting in centen voor een prijs, volgens de instellingen op de rij (dezelfde som als in de Liquid) */
    const kortingVoor = (prijs, rij) => {
      let korting = 0;
      if (rij.dataset.kortingSoort === 'procent') korting = Math.floor((prijs * Number(rij.dataset.kortingProcent || 0)) / 100);
      else korting = Number(rij.dataset.kortingBedrag || 0);
      return Math.max(0, Math.min(korting, prijs));
    };

    const tekenPrijs = (doel, prijs, rij, formaat) => {
      const korting = kortingVoor(prijs, rij);
      doel.textContent = '';
      const nu = document.createElement('span');
      nu.className = 'sora-ku__prijs-nu' + (korting > 0 ? ' sora-ku__prijs-nu--korting' : '');
      nu.textContent = geld(prijs - korting, formaat);
      doel.appendChild(nu);
      if (korting > 0) {
        const oud = document.createElement('s');
        oud.className = 'sora-ku__prijs-oud';
        oud.textContent = geld(prijs, formaat);
        doel.appendChild(oud);
      }
    };

    /* 'Kies een {optie}' + 'Maat' = 'Kies een maat' (optienaam klein, behalve aan het begin) */
    const optieLabel = (sjabloon, naam) => {
      const plek = (sjabloon || '').indexOf('{optie}');
      if (plek === -1) return naam;
      return sjabloon.split('{optie}').join(plek > 0 ? naam.toLowerCase() : naam);
    };

    /* Pop-up: een voor de hele pagina, gevuld vanuit de rij waarop geklikt is */
    const Popup = {
      dialog: null,
      blok: null,
      st: null,
      keuze: [],

      maak() {
        if (this.dialog) return;
        const d = document.createElement('dialog');
        d.className = 'sora-ku-popup';
        d.innerHTML =
          '<div class="sora-ku-popup__binnen">' +
          '<button type="button" class="sora-ku-popup__sluit" data-sluit><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
          '<div class="sora-ku-popup__kop"><img class="sora-ku-popup__beeld" alt="" hidden><div><p class="sora-ku-popup__titel"></p><p class="sora-ku-popup__prijs"></p></div></div>' +
          '<div class="sora-ku-popup__opties"></div>' +
          '<p class="sora-ku-popup__fout" role="status" aria-live="polite"></p>' +
          '<button type="button" class="sora-ku-popup__knop" data-voegtoe></button>' +
          '</div>';

        d.addEventListener('click', (e) => {
          if (e.target === d || e.target.closest('[data-sluit]')) {
            d.close();
            return;
          }
          const waarde = e.target.closest('[data-popup-waarde]');
          if (waarde && !waarde.disabled) {
            this.kies(Number(waarde.dataset.optie), waarde.dataset.popupWaarde);
            return;
          }
          if (e.target.closest('[data-voegtoe]')) this.toevoegen();
        });
        d.addEventListener('close', () => {
          const knop = this.st && this.st.rij.querySelector('[data-sora-ku-snel]');
          if (knop) knop.focus();
        });
        document.body.appendChild(d);
        this.dialog = d;
      },

      open(blok, st) {
        this.maak();
        this.blok = blok;
        this.st = st;
        const data = st.data;
        const d = this.dialog;
        d.setAttribute('style', blok.getAttribute('style') || '');
        d.setAttribute('aria-label', data.titel);
        d.querySelector('.sora-ku-popup__titel').textContent = data.titel;
        d.querySelector('[data-sluit]').setAttribute('aria-label', blok.dataset.popupSluiten || '');
        d.querySelector('.sora-ku-popup__fout').textContent = '';

        this.keuze = data.opties.map(() => null);
        if (st.keuze !== null) this.keuze[0] = st.keuze;
        data.opties.forEach((optie, i) => {
          if (this.keuze[i] !== null) return;
          const mogelijk = this.waarden(i);
          if (mogelijk.length === 1) this.keuze[i] = mogelijk[0].naam;
        });

        this.teken();
        if (!d.open) d.showModal();
      },

      past(v, negeer) {
        return this.keuze.every((k, j) => j === negeer || k === null || v.opties[j] === k);
      },

      waarden(i) {
        const data = this.st.data;
        return data.opties[i].waarden.filter((w) => data.varianten.some((v) => v.beschikbaar && v.opties[i] === w.naam));
      },

      kies(i, naam) {
        const data = this.st.data;
        this.keuze[i] = this.keuze[i] === naam ? null : naam;
        data.opties.forEach((optie, j) => {
          if (j === i || this.keuze[j] === null) return;
          const kan = data.varianten.some((v) => v.beschikbaar && this.past(v, -1));
          if (!kan) this.keuze[j] = null;
        });
        this.dialog.querySelector('.sora-ku-popup__fout').textContent = '';
        this.teken();
      },

      variant() {
        if (this.keuze.some((k) => k === null)) return null;
        return this.st.data.varianten.find((v) => this.past(v, -1)) || null;
      },

      teken() {
        const data = this.st.data;
        const d = this.dialog;
        const opties = d.querySelector('.sora-ku-popup__opties');
        opties.textContent = '';

        data.opties.forEach((optie, i) => {
          const groep = document.createElement('div');
          groep.setAttribute('role', 'group');
          groep.setAttribute('aria-label', optie.naam);
          const naam = document.createElement('p');
          naam.className = 'sora-ku-popup__naam';
          naam.textContent = optieLabel(this.blok.dataset.popupOptie, optie.naam) + (this.keuze[i] ? ': ' : '');
          if (this.keuze[i]) {
            const gekozen = document.createElement('span');
            gekozen.textContent = this.keuze[i];
            naam.appendChild(gekozen);
          }
          const rij = document.createElement('div');
          rij.className = 'sora-ku-popup__rij';

          this.waarden(i).forEach((w) => {
            const knop = document.createElement('button');
            knop.type = 'button';
            knop.className = 'sora-ku-popup__waarde';
            knop.dataset.optie = String(i);
            knop.dataset.popupWaarde = w.naam;
            knop.setAttribute('aria-pressed', this.keuze[i] === w.naam ? 'true' : 'false');
            /* Beschikbaarheid volgt de opties ervoor (zoals op de productpagina): een andere kleur kiezen kan altijd, een maat die dan niet past vervalt */
            const kan = data.varianten.some(
              (v) => v.beschikbaar && v.opties[i] === w.naam && this.keuze.every((k, j) => j >= i || k === null || v.opties[j] === k)
            );
            knop.disabled = !kan;
            if (optie.type === 'bolletjes' && (w.beeld || w.kleur)) {
              knop.classList.add('sora-ku-popup__waarde--bol');
              knop.setAttribute('aria-label', w.naam);
              knop.title = w.naam;
              if (w.beeld) knop.style.backgroundImage = 'url("' + w.beeld + '")';
              else knop.style.backgroundColor = w.kleur;
            } else {
              knop.textContent = w.naam;
            }
            rij.appendChild(knop);
          });

          groep.append(naam, rij);
          opties.appendChild(groep);
        });

        const v = this.variant();
        const voorbeeld = v || data.varianten.find((x) => x.beschikbaar && this.past(x, -1)) || data.varianten[0];
        if (voorbeeld) tekenPrijs(d.querySelector('.sora-ku-popup__prijs'), voorbeeld.prijsCent, this.st.rij, this.blok.dataset.geld);
        const beeld = d.querySelector('.sora-ku-popup__beeld');
        const bron = (voorbeeld && voorbeeld.beeld) || data.beeld;
        if (bron) {
          beeld.src = bron;
          beeld.hidden = false;
        } else {
          beeld.hidden = true;
        }

        const knop = d.querySelector('[data-voegtoe]');
        knop.textContent = this.blok.dataset.popupKnop || '';
        knop.disabled = !(v && v.beschikbaar);
      },

      async toevoegen() {
        const v = this.variant();
        if (!v || !v.beschikbaar) return;
        const knop = this.dialog.querySelector('[data-voegtoe]');
        knop.disabled = true;
        knop.textContent = this.blok.dataset.popupBezig || '';
        const gelukt = await voegToe(v.id, this.st.rij);
        if (gelukt) {
          const blok = this.blok;
          const st = this.st;
          if (st.keuze !== this.keuze[0]) blok.kies(st, this.keuze[0]);
          this.dialog.close();
          blok.toonKlaar(st);
        } else {
          this.dialog.querySelector('.sora-ku-popup__fout').textContent = this.blok.dataset.fout || '';
          this.teken();
        }
      },
    };

    class SoraKruisverkoop extends HTMLElement {
      connectedCallback() {
        if (this.klaar) return;
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.connectedCallback(), { once: true });
          return;
        }
        this.klaar = true;
        this.melding = this.querySelector('.sora-ku__melding');
        this.staten = new Map();

        this.querySelectorAll('[data-sora-ku-rij]').forEach((rij) => {
          let data = null;
          try {
            const bron = rij.querySelector('[data-sora-ku-data]');
            data = bron ? JSON.parse(bron.textContent) : null;
          } catch (fout) {
            data = null;
          }
          const prijs = rij.querySelector('[data-sora-ku-prijs]');
          const st = { rij, data, keuze: null, prijsOrigineel: prijs ? prijs.innerHTML : '', timer: null };
          this.staten.set(rij, st);
          /* Maar een variant op voorraad (bij meerdere varianten): die alvast kiezen */
          if (data && data.varianten.length > 1) {
            const op = data.varianten.filter((v) => v.beschikbaar);
            if (op.length === 1) this.kies(st, op[0].opties[0]);
          }
        });

        this.addEventListener('click', this.opKlik);
        this.addEventListener('change', this.opWijziging);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.opKlik);
        this.removeEventListener('change', this.opWijziging);
      }

      staatVan(element) {
        const rij = element.closest('[data-sora-ku-rij]');
        return rij ? this.staten.get(rij) : null;
      }

      opWijziging = (event) => {
        const select = event.target.closest('[data-sora-ku-select]');
        const st = select && this.staatVan(select);
        if (st) this.kies(st, select.value || null);
      };

      opKlik = (event) => {
        const waarde = event.target.closest('[data-sora-ku-waarde]');
        if (waarde) {
          const st = this.staatVan(waarde);
          if (!st) return;
          const naam = waarde.dataset.soraKuWaarde;
          this.kies(st, st.keuze === naam ? null : naam);
          return;
        }
        const snel = event.target.closest('[data-sora-ku-snel]');
        if (snel) {
          const st = this.staatVan(snel);
          if (st && !snel.disabled && snel.dataset.status !== 'bezig') this.snel(st, snel);
        }
      };

      kandidaten(st, naam) {
        if (!st.data || naam === null) return [];
        return st.data.varianten.filter((v) => v.beschikbaar && v.opties[0] === naam);
      }

      vasteVariant(st) {
        if (!st.data) return null;
        const alle = st.data.varianten;
        if (alle.length === 1) return alle[0];
        if (st.keuze === null) return null;
        const kandidaten = this.kandidaten(st, st.keuze);
        if (st.data.opties.length === 1 || kandidaten.length === 1) return kandidaten[0] || null;
        return null;
      }

      kies(st, naam) {
        st.keuze = naam;
        st.rij.querySelectorAll('[data-sora-ku-waarde]').forEach((knop) => {
          knop.setAttribute('aria-pressed', knop.dataset.soraKuWaarde === naam ? 'true' : 'false');
        });
        const select = st.rij.querySelector('[data-sora-ku-select]');
        if (select && select.value !== (naam || '')) select.value = naam || '';
        if (this.melding) this.melding.textContent = '';
        this.toonVariant(st, this.kandidaten(st, naam)[0] || null);
      }

      toonVariant(st, v) {
        const prijs = st.rij.querySelector('[data-sora-ku-prijs]');
        if (prijs) {
          if (v) tekenPrijs(prijs, v.prijsCent, st.rij, this.dataset.geld);
          else prijs.innerHTML = st.prijsOrigineel;
        }

        const beeld = st.rij.querySelector('.sora-ku__foto-beeld');
        if (beeld) {
          if (beeld.dataset.soraKuSrc === undefined) beeld.dataset.soraKuSrc = beeld.getAttribute('src') || '';
          beeld.removeAttribute('srcset');
          beeld.setAttribute('src', v && v.beeld ? v.beeld : beeld.dataset.soraKuSrc);
        }

        st.rij.querySelectorAll('[data-sora-ku-link]').forEach((link) => {
          if (link.dataset.soraKuHref === undefined) link.dataset.soraKuHref = link.getAttribute('href') || '';
          link.setAttribute('href', v && v.url ? v.url : link.dataset.soraKuHref);
        });
      }

      async snel(st, knop) {
        if (!st.data) return;
        const v = this.vasteVariant(st);
        if (!v) {
          Popup.open(this, st);
          return;
        }
        if (!v.beschikbaar) return;
        knop.dataset.status = 'bezig';
        const gelukt = await voegToe(v.id, knop);
        delete knop.dataset.status;
        if (gelukt) {
          if (this.melding) this.melding.textContent = '';
          this.toonKlaar(st);
        } else if (this.melding) {
          this.melding.textContent = this.dataset.fout || '';
        }
      }

      toonKlaar(st) {
        const knop = st.rij.querySelector('[data-sora-ku-snel]');
        if (!knop) return;
        knop.dataset.status = 'klaar';
        clearTimeout(st.timer);
        st.timer = setTimeout(() => {
          if (knop.dataset.status === 'klaar') delete knop.dataset.status;
        }, 1800);
      }
    }

    customElements.define('sora-kruisverkoop', SoraKruisverkoop);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sora-favorieten-hart"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.soraFavorietenHartActief) return;
    window.soraFavorietenHartActief = true;

    const SLEUTEL = 'sora-favorieten';

    const lees = () => {
      try {
        const waarde = JSON.parse(localStorage.getItem(SLEUTEL) || '[]');
        return Array.isArray(waarde) ? waarde.filter((handle) => typeof handle === 'string') : [];
      } catch (fout) {
        return [];
      }
    };

    const bijwerken = (handles) => {
      const lijst = Array.isArray(handles) ? handles : lees();
      const aantal = lijst.length;

      document.querySelectorAll('[data-sora-favorieten-hart]').forEach((hart) => {
        const label = (hart.dataset.label || '').replace('{aantal}', String(aantal));
        if (label && hart.getAttribute('aria-label') !== label) hart.setAttribute('aria-label', label);

        const actief = aantal > 0 ? 'true' : 'false';
        if (hart.dataset.actief !== actief) hart.dataset.actief = actief;

        const teller = hart.querySelector('[data-sora-favorieten-teller]');
        if (!teller) return;

        const max = parseInt(hart.dataset.max, 10) || 99;
        const tonen = aantal > 0 || hart.dataset.toonNul === 'true';
        const tekst = aantal > max ? `${max}+` : String(aantal);

        if (teller.textContent !== tekst) teller.textContent = tekst;
        if (teller.hidden === tonen) teller.hidden = !tonen;
      });
    };

    let gepland = false;
    const plan = () => {
      if (gepland) return;
      gepland = true;
      requestAnimationFrame(() => {
        gepland = false;
        bijwerken();
      });
    };

    document.addEventListener('sora:favorieten-gewijzigd', (gebeurtenis) => {
      bijwerken(gebeurtenis.detail && gebeurtenis.detail.handles);
    });
    window.addEventListener('storage', (gebeurtenis) => {
      if (gebeurtenis.key === SLEUTEL) bijwerken();
    });
    window.addEventListener('pageshow', plan);
    document.addEventListener('shopify:section:load', plan);

    const start = () => {
      bijwerken();
      if ('MutationObserver' in window) {
        new MutationObserver(plan).observe(document.body, { childList: true, subtree: true });
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sora-favorite-button"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.soraFavorieten) return;

    const SLEUTEL = 'sora-favorieten';
    let geheugen = [];

    const lees = () => {
      try {
        const waarde = JSON.parse(localStorage.getItem(SLEUTEL) || '[]');
        geheugen = Array.isArray(waarde) ? waarde.filter((h) => typeof h === 'string') : [];
      } catch (fout) {
        /* opslag niet beschikbaar: werk door met het geheugen van deze pagina */
      }
      return geheugen.slice();
    };

    const bewaar = (lijst) => {
      geheugen = lijst;
      try {
        localStorage.setItem(SLEUTEL, JSON.stringify(lijst));
      } catch (fout) {
        /* opslag niet beschikbaar */
      }
    };

    const bijwerken = () => {
      const lijst = lees();
      document.querySelectorAll('[data-sora-favoriet]').forEach((knop) => {
        const actief = lijst.includes(knop.dataset.handle);
        knop.setAttribute('aria-pressed', actief ? 'true' : 'false');
        knop.setAttribute('aria-label', actief ? knop.dataset.labelUit : knop.dataset.labelAan);
      });
    };

    const melden = () => {
      document.dispatchEvent(new CustomEvent('sora:favorieten-gewijzigd', { detail: { handles: lees() } }));
    };

    const wissel = (handle) => {
      if (!handle) return;
      const lijst = lees();
      const plek = lijst.indexOf(handle);
      if (plek === -1) lijst.push(handle);
      else lijst.splice(plek, 1);
      bewaar(lijst);
      bijwerken();
      melden();
    };

    window.soraFavorieten = {
      lijst: lees,
      bevat: (handle) => lees().includes(handle),
      wissel,
      aantal: () => lees().length,
    };

    document.addEventListener('click', (gebeurtenis) => {
      const knop = gebeurtenis.target.closest('[data-sora-favoriet]');
      if (!knop) return;
      gebeurtenis.preventDefault();
      gebeurtenis.stopPropagation();
      wissel(knop.dataset.handle);
    });

    window.addEventListener('storage', (gebeurtenis) => {
      if (gebeurtenis.key === SLEUTEL) {
        bijwerken();
        melden();
      }
    });

    let gepland = false;
    const plan = () => {
      if (gepland) return;
      gepland = true;
      requestAnimationFrame(() => {
        gepland = false;
        bijwerken();
      });
    };

    const start = () => {
      bijwerken();
      if ('MutationObserver' in window) {
        new MutationObserver(plan).observe(document.body, { childList: true, subtree: true });
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
    document.addEventListener('shopify:section:load', plan);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sora-load-more"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.soraLaadMeer) return;
    window.soraLaadMeer = true;

    function zoekRaster(root) {
      var sectie = root.closest('.shopify-section') || document;
      return sectie.querySelector('ul.product-grid');
    }

    async function laad(knop) {
      var root = knop.closest('[data-sora-laad-meer]');
      if (!root || knop.getAttribute('aria-busy') === 'true') return;
      var raster = zoekRaster(root);
      if (!raster) {
        window.location.href = knop.href;
        return;
      }

      var tekst = knop.querySelector('[data-sora-lm-knoptekst]');
      var fout = root.querySelector('[data-sora-lm-fout]');
      knop.setAttribute('aria-busy', 'true');
      if (tekst && root.dataset.laden) tekst.textContent = root.dataset.laden;
      if (fout) fout.hidden = true;

      try {
        var url = new URL(knop.href, window.location.origin);
        url.searchParams.set('section_id', root.dataset.sectie);
        var antwoord = await fetch(url.toString(), { headers: { Accept: 'text/html' } });
        if (!antwoord.ok) throw new Error(String(antwoord.status));
        var doc = new DOMParser().parseFromString(await antwoord.text(), 'text/html');

        var nieuwRaster = doc.querySelector('ul.product-grid');
        var items = nieuwRaster ? Array.prototype.filter.call(nieuwRaster.children, function (el) {
          return el.tagName === 'LI' && !el.hasAttribute('data-sora-promotegel');
        }) : [];
        var eerste = null;
        items.forEach(function (li) {
          var kopie = document.importNode(li, true);
          raster.appendChild(kopie);
          if (!eerste) eerste = kopie;
        });

        var nieuwRoot = doc.querySelector('[data-sora-laad-meer]');
        if (nieuwRoot) {
          var teller = root.querySelector('[data-sora-lm-teller]');
          var nieuweTeller = nieuwRoot.querySelector('[data-sora-lm-teller]');
          if (teller && nieuweTeller) teller.textContent = nieuweTeller.textContent;
          var vul = root.querySelector('[data-sora-lm-vul]');
          var nieuweVul = nieuwRoot.querySelector('[data-sora-lm-vul]');
          if (vul && nieuweVul) vul.style.width = nieuweVul.style.width;
          var nieuweKnop = nieuwRoot.querySelector('[data-sora-lm-knop]');
          if (nieuweKnop) {
            knop.href = nieuweKnop.getAttribute('href');
          } else {
            var klaar = nieuwRoot.querySelector('.sora-lm__klaar');
            if (klaar) knop.replaceWith(document.importNode(klaar, true));
            else knop.remove();
          }
        }

        if (root.dataset.adres === 'true') {
          var pagina = url.searchParams.get('page');
          var adres = new URL(window.location.href);
          if (pagina) adres.searchParams.set('page', pagina);
          window.history.replaceState(window.history.state, '', adres.toString());
        }

        if (eerste && root.dataset.focus === 'true') {
          var doel = eerste.querySelector('a[href]');
          if (doel) doel.focus({ preventScroll: true });
        }
      } catch (e) {
        if (fout) {
          fout.textContent = root.dataset.fout || '';
          fout.hidden = false;
        }
      } finally {
        if (knop.isConnected) {
          knop.removeAttribute('aria-busy');
          if (tekst) tekst.textContent = root.dataset.knop || tekst.textContent;
        }
      }
    }

    document.addEventListener('click', function (gebeurtenis) {
      var knop = gebeurtenis.target.closest ? gebeurtenis.target.closest('[data-sora-lm-knop]') : null;
      if (!knop) return;
      if (gebeurtenis.metaKey || gebeurtenis.ctrlKey || gebeurtenis.shiftKey || gebeurtenis.button === 1) return;
      gebeurtenis.preventDefault();
      laad(knop);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sora-menu-accordion"] && !Shopify.designMode) return;
  try {
    (function () {
    var desktop = window.matchMedia('(min-width: 750px)');

    function pas(details) {
      var vast = desktop.matches && details.getAttribute('data-desktop-open') === 'true';
      var kop = details.querySelector('summary');
      if (vast) {
        details.setAttribute('data-vast', 'true');
        details.open = true;
        if (kop) kop.setAttribute('tabindex', '-1');
      } else if (details.hasAttribute('data-vast')) {
        details.removeAttribute('data-vast');
        details.open = details.getAttribute('data-mobiel-open') === 'true';
        if (kop) kop.removeAttribute('tabindex');
      }
    }

    function alle() {
      document.querySelectorAll('[data-sora-menu-accordeon]').forEach(pas);
    }

    document.addEventListener('click', function (gebeurtenis) {
      var kop = gebeurtenis.target.closest ? gebeurtenis.target.closest('.sora-ma__kop') : null;
      if (!kop) return;
      var details = kop.parentElement;
      if (details && details.hasAttribute('data-vast')) gebeurtenis.preventDefault();
    });

    if (desktop.addEventListener) {
      desktop.addEventListener('change', alle);
    } else if (desktop.addListener) {
      desktop.addListener(alle);
    }
    document.addEventListener('shopify:section:load', alle);
    document.addEventListener('shopify:block:load', alle);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', alle);
    } else {
      alle();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sora-product-card-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.soraFavorieten) return;

    const SLEUTEL = 'sora-favorieten';
    let geheugen = [];

    const lees = () => {
      try {
        const waarde = JSON.parse(localStorage.getItem(SLEUTEL) || '[]');
        geheugen = Array.isArray(waarde) ? waarde.filter((h) => typeof h === 'string') : [];
      } catch (fout) {
        /* opslag niet beschikbaar: werk door met het geheugen van deze pagina */
      }
      return geheugen.slice();
    };

    const bewaar = (lijst) => {
      geheugen = lijst;
      try {
        localStorage.setItem(SLEUTEL, JSON.stringify(lijst));
      } catch (fout) {
        /* opslag niet beschikbaar */
      }
    };

    const bijwerken = () => {
      const lijst = lees();
      document.querySelectorAll('[data-sora-favoriet]').forEach((knop) => {
        const actief = lijst.includes(knop.dataset.handle);
        knop.setAttribute('aria-pressed', actief ? 'true' : 'false');
        knop.setAttribute('aria-label', actief ? knop.dataset.labelUit : knop.dataset.labelAan);
      });
    };

    const melden = () => {
      document.dispatchEvent(new CustomEvent('sora:favorieten-gewijzigd', { detail: { handles: lees() } }));
    };

    const wissel = (handle) => {
      if (!handle) return;
      const lijst = lees();
      const plek = lijst.indexOf(handle);
      if (plek === -1) lijst.push(handle);
      else lijst.splice(plek, 1);
      bewaar(lijst);
      bijwerken();
      melden();
    };

    window.soraFavorieten = {
      lijst: lees,
      bevat: (handle) => lees().includes(handle),
      wissel,
      aantal: () => lees().length,
    };

    document.addEventListener('click', (gebeurtenis) => {
      const knop = gebeurtenis.target.closest('[data-sora-favoriet]');
      if (!knop) return;
      gebeurtenis.preventDefault();
      gebeurtenis.stopPropagation();
      wissel(knop.dataset.handle);
    });

    window.addEventListener('storage', (gebeurtenis) => {
      if (gebeurtenis.key === SLEUTEL) {
        bijwerken();
        melden();
      }
    });

    let gepland = false;
    const plan = () => {
      if (gepland) return;
      gepland = true;
      requestAnimationFrame(() => {
        gepland = false;
        bijwerken();
      });
    };

    const start = () => {
      bijwerken();
      if ('MutationObserver' in window) {
        new MutationObserver(plan).observe(document.body, { childList: true, subtree: true });
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
    document.addEventListener('shopify:section:load', plan);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sora-product-card"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('sora-productkaart')) return;

    const routes = () => {
      const r = (window.Theme && window.Theme.routes) || {};
      const winkelwagen = r.cart_url || '/cart';
      return { toevoegen: r.cart_add_url || '/cart/add.js', winkelwagen, json: winkelwagen + '.js' };
    };

    let events = null;
    const laadEvents = async () => {
      if (events !== null) return events;
      try {
        events = await import('@shopify/events');
      } catch (fout) {
        events = false;
      }
      return events;
    };

    const postJson = async (url, body) => {
      const antwoord = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await antwoord.json().catch(() => ({}));
      return { ok: antwoord.ok && !data.status, data };
    };

    /* Voegt een variant toe en laat Horizon (winkelwagenlade, teller) meelopen via de cartevents. */
    const voegToe = async (variantId, bron) => {
      const r = routes();
      const ev = await laadEvents();
      let uitgesteld = null;
      if (ev && ev.CartLinesUpdateEvent) {
        try {
          uitgesteld = ev.CartLinesUpdateEvent.createPromise();
          bron.dispatchEvent(
            new ev.CartLinesUpdateEvent({
              action: 'add',
              context: 'product',
              lines: [{ merchandiseId: String(variantId), quantity: 1 }],
              promise: uitgesteld.promise,
            })
          );
        } catch (fout) {
          uitgesteld = null;
        }
      }

      const sectieIds = Array.from(document.querySelectorAll('cart-items-component'))
        .map((c) => c.dataset.sectionId)
        .filter(Boolean)
        .join(',');

      let gelukt = false;
      let secties;
      try {
        const resultaat = await postJson(r.toevoegen, {
          items: [{ id: variantId, quantity: 1 }],
          sections: sectieIds || undefined,
        });
        gelukt = resultaat.ok;
        secties = resultaat.data.sections;
      } catch (fout) {
        gelukt = false;
      }

      if (uitgesteld) {
        let wagen = null;
        try {
          const antwoord = await fetch(r.json, { headers: { Accept: 'application/json' } });
          wagen = await antwoord.json();
        } catch (fout) {
          wagen = null;
        }
        if (wagen && wagen.items) {
          uitgesteld.resolve({
            cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(wagen),
            detail: {
              items: wagen.items,
              source: 'sora-productkaart',
              sourceId: bron.id || '',
              itemCount: wagen.item_count,
              sections: secties,
              didError: !gelukt,
            },
          });
        } else {
          uitgesteld.reject(new Error('Winkelwagen niet opgehaald'));
        }
      } else if (gelukt) {
        window.location.assign(r.winkelwagen);
      }
      return gelukt;
    };

    const maakPrijs = (doel, variant, kortingSjabloon) => {
      doel.textContent = '';
      const nu = document.createElement('span');
      nu.className = 'sora-pk__nu';
      nu.textContent = variant.prijs;
      doel.appendChild(nu);
      if (variant.verprijs) {
        const oud = document.createElement('s');
        oud.className = 'sora-pk__oud';
        oud.textContent = variant.verprijs;
        doel.appendChild(oud);
        if (kortingSjabloon && variant.verprijsCent > variant.prijsCent) {
          const procent = Math.max(1, Math.round(((variant.verprijsCent - variant.prijsCent) * 100) / variant.verprijsCent));
          const badge = document.createElement('span');
          badge.className = 'sora-pk-popup__korting';
          badge.textContent = kortingSjabloon.split('{percentage}').join(String(procent));
          doel.appendChild(badge);
        }
      }
    };

    /* 'Kies een {optie}' + 'Maat' = 'Kies een maat' (optienaam klein, behalve aan het begin) */
    const optieLabel = (sjabloon, naam) => {
      const plek = (sjabloon || '').indexOf('{optie}');
      if (plek === -1) return naam;
      return sjabloon.split('{optie}').join(plek > 0 ? naam.toLowerCase() : naam);
    };

    const BADGE_VARS = ['--sora-status-vlak', '--sora-status-kleur', '--sora-badge-radius', '--sora-badge-maat', '--sora-badge-gewicht', '--sora-badge-transform'];

    /* Pop-up: een voor de hele pagina, gevuld vanuit de kaart waarop geklikt is */
    const Popup = {
      dialog: null,
      kaart: null,
      keuze: [],

      maak() {
        if (this.dialog) return;
        const d = document.createElement('dialog');
        d.className = 'sora-pk-popup';
        d.innerHTML =
          '<div class="sora-pk-popup__binnen">' +
          '<button type="button" class="sora-pk-popup__sluit" data-sluit><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
          '<div class="sora-pk-popup__kop"><img class="sora-pk-popup__beeld" alt="" hidden><div><p class="sora-pk-popup__titel"></p><p class="sora-pk-popup__prijs"></p></div></div>' +
          '<div class="sora-pk-popup__opties"></div>' +
          '<p class="sora-pk-popup__fout" role="status" aria-live="polite"></p>' +
          '<button type="button" class="sora-pk-popup__knop" data-voegtoe></button>' +
          '</div>';

        d.addEventListener('click', (e) => {
          if (e.target === d || e.target.closest('[data-sluit]')) {
            d.close();
            return;
          }
          const waarde = e.target.closest('[data-popup-waarde]');
          if (waarde && !waarde.disabled) {
            this.kies(Number(waarde.dataset.optie), waarde.dataset.popupWaarde);
            return;
          }
          if (e.target.closest('[data-voegtoe]')) this.toevoegen();
        });
        d.addEventListener('close', () => {
          const knop = this.kaart && this.kaart.querySelector('[data-sora-pk-snel]');
          if (knop) knop.focus();
        });
        document.body.appendChild(d);
        this.dialog = d;
      },

      past(v, negeer) {
        return this.keuze.every((k, j) => j === negeer || k === null || v.opties[j] === k);
      },

      open(kaart) {
        this.maak();
        this.kaart = kaart;
        const data = kaart.data;
        const d = this.dialog;
        let stijl = kaart.getAttribute('style') || '';
        const kaartElement = kaart.closest('product-card');
        const laag = kaartElement && kaartElement.querySelector('.sora-kaart-laag');
        if (laag) {
          const berekend = getComputedStyle(laag);
          BADGE_VARS.forEach((naam) => {
            const waarde = berekend.getPropertyValue(naam).trim();
            if (waarde) stijl += naam + ': ' + waarde + ';';
          });
        }
        d.setAttribute('style', stijl);
        d.setAttribute('aria-label', data.titel);
        d.querySelector('.sora-pk-popup__titel').textContent = data.titel;
        d.querySelector('[data-sluit]').setAttribute('aria-label', data.tekst.sluiten);
        d.querySelector('.sora-pk-popup__fout').textContent = '';

        this.keuze = data.opties.map(() => null);
        if (kaart.keuze !== null) this.keuze[0] = kaart.keuze;
        data.opties.forEach((optie, i) => {
          if (this.keuze[i] !== null) return;
          const mogelijk = this.waarden(i);
          if (mogelijk.length === 1) this.keuze[i] = mogelijk[0].naam;
        });

        this.teken();
        if (!d.open) d.showModal();
      },

      waarden(i) {
        const data = this.kaart.data;
        return data.opties[i].waarden.filter((w) => data.varianten.some((v) => v.beschikbaar && v.opties[i] === w.naam));
      },

      kies(i, naam) {
        const data = this.kaart.data;
        this.keuze[i] = this.keuze[i] === naam ? null : naam;
        data.opties.forEach((optie, j) => {
          if (j === i || this.keuze[j] === null) return;
          const kan = data.varianten.some((v) => v.beschikbaar && this.past(v, -1));
          if (!kan) this.keuze[j] = null;
        });
        this.dialog.querySelector('.sora-pk-popup__fout').textContent = '';
        this.teken();
      },

      variant() {
        if (this.keuze.some((k) => k === null)) return null;
        return this.kaart.data.varianten.find((v) => this.past(v, -1)) || null;
      },

      teken() {
        const data = this.kaart.data;
        const d = this.dialog;
        const opties = d.querySelector('.sora-pk-popup__opties');
        opties.textContent = '';

        data.opties.forEach((optie, i) => {
          const groep = document.createElement('div');
          groep.setAttribute('role', 'group');
          groep.setAttribute('aria-label', optie.naam);
          const naam = document.createElement('p');
          naam.className = 'sora-pk-popup__naam';
          naam.textContent = optieLabel(data.tekst.optie, optie.naam) + (this.keuze[i] ? ': ' : '');
          if (this.keuze[i]) {
            const gekozen = document.createElement('span');
            gekozen.textContent = this.keuze[i];
            naam.appendChild(gekozen);
          }
          const rij = document.createElement('div');
          rij.className = 'sora-pk-popup__rij';

          this.waarden(i).forEach((w) => {
            const knop = document.createElement('button');
            knop.type = 'button';
            knop.className = 'sora-pk-popup__waarde';
            knop.dataset.optie = String(i);
            knop.dataset.popupWaarde = w.naam;
            knop.setAttribute('aria-pressed', this.keuze[i] === w.naam ? 'true' : 'false');
            /* Beschikbaarheid volgt de opties ervoor (zoals op de productpagina): een andere kleur kiezen kan altijd, een maat die dan niet past vervalt */
            const kan = data.varianten.some(
              (v) => v.beschikbaar && v.opties[i] === w.naam && this.keuze.every((k, j) => j >= i || k === null || v.opties[j] === k)
            );
            knop.disabled = !kan;
            if (optie.type === 'bolletjes' && (w.beeld || w.kleur)) {
              knop.classList.add('sora-pk-popup__waarde--bol');
              knop.setAttribute('aria-label', w.naam);
              knop.title = w.naam;
              if (w.beeld) knop.style.backgroundImage = 'url("' + w.beeld + '")';
              else knop.style.backgroundColor = w.kleur;
            } else {
              knop.textContent = w.naam;
            }
            rij.appendChild(knop);
          });

          groep.append(naam, rij);
          opties.appendChild(groep);
        });

        const v = this.variant();
        const voorbeeld = v || data.varianten.find((x) => x.beschikbaar && this.past(x, -1)) || data.varianten[0];
        const prijs = d.querySelector('.sora-pk-popup__prijs');
        if (voorbeeld) maakPrijs(prijs, voorbeeld, data.tekst.korting);
        const beeld = d.querySelector('.sora-pk-popup__beeld');
        const bron = (voorbeeld && voorbeeld.beeld) || data.beeld;
        if (bron) {
          beeld.src = bron;
          beeld.hidden = false;
        } else {
          beeld.hidden = true;
        }

        const knop = d.querySelector('[data-voegtoe]');
        knop.textContent = data.tekst.knop;
        knop.disabled = !(v && v.beschikbaar);
      },

      async toevoegen() {
        const v = this.variant();
        if (!v || !v.beschikbaar) return;
        const knop = this.dialog.querySelector('[data-voegtoe]');
        knop.disabled = true;
        knop.textContent = this.kaart.data.tekst.bezig;
        const gelukt = await voegToe(v.id, this.kaart);
        if (gelukt) {
          const kaart = this.kaart;
          if (kaart.keuze !== this.keuze[0]) kaart.kies(this.keuze[0]);
          this.dialog.close();
          kaart.toonKlaar();
        } else {
          this.dialog.querySelector('.sora-pk-popup__fout').textContent = this.kaart.data.tekst.fout;
          this.teken();
        }
      },
    };

    class SoraProductkaart extends HTMLElement {
      connectedCallback() {
        if (this.klaar) return;
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.connectedCallback(), { once: true });
          return;
        }
        this.klaar = true;
        this.keuze = null;
        try {
          const bron = this.querySelector('[data-sora-pk-data]');
          this.data = bron ? JSON.parse(bron.textContent) : null;
        } catch (fout) {
          this.data = null;
        }
        const prijs = this.querySelector('[data-sora-pk-prijs]');
        this.prijsOrigineel = prijs ? prijs.innerHTML : '';

        this.addEventListener('click', (e) => this.opKlik(e));
        this.addEventListener('change', (e) => {
          const select = e.target.closest('[data-sora-pk-select]');
          if (select) this.kies(select.value || null);
        });

        /* Maar een variant op voorraad (bij meerdere varianten): die alvast kiezen */
        if (this.data && this.data.varianten.length > 1) {
          const op = this.data.varianten.filter((v) => v.beschikbaar);
          if (op.length === 1) this.kies(op[0].opties[0]);
        }
      }

      opKlik(e) {
        const waarde = e.target.closest('[data-sora-pk-waarde]');
        if (waarde) {
          e.preventDefault();
          e.stopPropagation();
          const naam = waarde.dataset.soraPkWaarde;
          this.kies(this.keuze === naam ? null : naam);
          return;
        }
        const snel = e.target.closest('[data-sora-pk-snel]');
        if (snel) {
          e.preventDefault();
          e.stopPropagation();
          if (!snel.disabled && snel.dataset.status !== 'bezig') this.snel(snel);
        }
      }

      kandidaten(naam) {
        if (!this.data || naam === null) return [];
        return this.data.varianten.filter((v) => v.beschikbaar && v.opties[0] === naam);
      }

      vasteVariant() {
        if (!this.data) return null;
        const alle = this.data.varianten;
        if (alle.length === 1) return alle[0];
        if (this.keuze === null) return null;
        const kandidaten = this.kandidaten(this.keuze);
        if (this.data.opties.length === 1 || kandidaten.length === 1) return kandidaten[0] || null;
        return null;
      }

      kies(naam) {
        this.keuze = naam;
        this.querySelectorAll('[data-sora-pk-waarde]').forEach((knop) => {
          knop.setAttribute('aria-pressed', knop.dataset.soraPkWaarde === naam ? 'true' : 'false');
        });
        const select = this.querySelector('[data-sora-pk-select]');
        if (select && select.value !== (naam || '')) select.value = naam || '';
        this.querySelector('[data-sora-pk-melding]').textContent = '';
        this.toonVariant(this.kandidaten(naam)[0] || null);
      }

      toonVariant(v) {
        const prijs = this.querySelector('[data-sora-pk-prijs]');
        if (prijs) {
          if (v) maakPrijs(prijs, v);
          else prijs.innerHTML = this.prijsOrigineel;
        }

        const kaart = this.closest('product-card') || this.parentElement;
        if (!kaart) return;

        const beeld =
          kaart.querySelector('.card-gallery slideshow-slide[aria-hidden="false"] img') ||
          kaart.querySelector('.card-gallery img');
        if (beeld) {
          if (beeld.dataset.soraPkSrc === undefined) {
            beeld.dataset.soraPkSrc = beeld.getAttribute('src') || '';
            beeld.dataset.soraPkSrcset = beeld.getAttribute('srcset') || '';
          }
          const nieuwSrc = v && v.beeld ? v.beeld : beeld.dataset.soraPkSrc;
          const nieuwSet = v && v.beeld ? v.srcset || '' : beeld.dataset.soraPkSrcset;
          if (nieuwSet) beeld.setAttribute('srcset', nieuwSet);
          else beeld.removeAttribute('srcset');
          beeld.setAttribute('src', nieuwSrc);
        }

        kaart.querySelectorAll('a.product-card__link, .card-gallery a[href], [data-sora-pk-link]').forEach((link) => {
          if (link.dataset.soraPkHref === undefined) link.dataset.soraPkHref = link.getAttribute('href') || '';
          link.setAttribute('href', v && v.url ? v.url : link.dataset.soraPkHref);
        });
      }

      async snel(knop) {
        if (!this.data) return;
        const v = this.vasteVariant();
        if (!v) {
          Popup.open(this);
          return;
        }
        if (!v.beschikbaar) return;
        knop.dataset.status = 'bezig';
        const gelukt = await voegToe(v.id, this);
        delete knop.dataset.status;
        if (gelukt) this.toonKlaar();
        else this.querySelector('[data-sora-pk-melding]').textContent = this.data.tekst.fout;
      }

      toonKlaar() {
        const knop = this.querySelector('[data-sora-pk-snel]');
        if (!knop) return;
        knop.dataset.status = 'klaar';
        clearTimeout(this.klaarTimer);
        this.klaarTimer = setTimeout(() => {
          if (knop.dataset.status === 'klaar') delete knop.dataset.status;
        }, 1800);
      }
    }

    customElements.define('sora-productkaart', SoraProductkaart);
  })();
  } catch(e) { console.error(e); }
})();

})();
